import { createSlice } from "@reduxjs/toolkit";
import { SHIFT_TYPES } from "../../../secretary/data";

const initialState = {
  doctorsSelect: {
    data: [],
    isLoading: false,
    message: null,
  },
  shiftTypes: SHIFT_TYPES,
  message: null,
  isLoading: false,
  workShifts: {
    data: [],
    isLoading: false,
    message: null,
  },
  params: {
    doctorId: "",
    shiftType: "",
    startDate: "",
    endDate: "",
  },
  pageSize: "5",
  page: "1",
  totalPages: 1,
};

const resetState = (state, keys) => {
  keys.forEach((key) => {
    state[key] = initialState[key];
  });
};

export const workShiftSlice = createSlice({
  name: "workShift",
  initialState,
  reducers: {
    loadingDoctorsSelect: (state) => {
      state.doctorsSelect.isLoading = true;
      state.doctorsSelect.message = null;
    },
    loadedDoctorsSelect: (state, { payload }) => {
      state.doctorsSelect.data = payload.doctors;
      state.doctorsSelect.isLoading = false;
      state.doctorsSelect.message = {
        type: "success",
        text: payload.message,
      };
    },
    failedDoctorsSelect: (state, { payload }) => {
      state.doctorsSelect.isLoading = false;
      state.doctorsSelect.message = {
        type: "error",
        text: payload,
      };
    },
    loading: (state) => {
      state.isLoading = true;
      state.message = null;
    },
    loaded: (state) => {
      state.isLoading = false;
      state.message = null;
    },
    errorMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "error",
        text: payload,
      };
    },
    successMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "success",
        text: payload,
      };
    },
    loadingWorkShifts: (state) => {
      state.workShifts.isLoading = true;
      state.workShifts.message = null;
      state.message = null;
    },
    loadedWorkShifts: (state, { payload }) => {
      state.workShifts.data = payload.workShifts;
      state.workShifts.isLoading = false;
      state.page = payload.page;
      state.totalPages = payload.totalPages;
      state.workShifts.message = {
        type: "success",
        text: payload.message,
      };
    },
    failedWorkShifts: (state, { payload }) => {
      state.workShifts.isLoading = false;
      state.workShifts.message = {
        type: "error",
        text: payload,
      };
    },
    addWorkShift: (state, { payload }) => {
      state.workShifts.data.unshift(payload);
    },
    changeParams: (state, { payload }) => {
      state.params = payload;
    },
    resetParams: (state) => {
      resetState(state, ["params"]);
    },
    changePageSize: (state, { payload }) => {
      state.pageSize = payload;
    },
    changePage: (state, { payload }) => {
      state.page = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loadingDoctorsSelect,
  loadedDoctorsSelect,
  failedDoctorsSelect,
  loading,
  loaded,
  errorMessage,
  successMessage,
  loadingWorkShifts,
  loadedWorkShifts,
  failedWorkShifts,
  addWorkShift,
  changeParams,
  resetParams,
  changePageSize,
  changePage,
} = workShiftSlice.actions;
